var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 8,
    viewBox: "0 0 8 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.01534 5.7705L5.23634 3.9925L7.01434 2.2145C7.35634 1.8735 7.35634 1.3185 7.01434 0.977501C6.67234 0.633501 6.11934 0.634501 5.77734 0.976501L3.99834 2.7545L2.21934 0.974501C1.87734 0.632501 1.32334 0.634501 0.981336 0.974501C0.640336 1.3165 0.640336 1.8715 0.981336 2.2125L2.76134 3.9925L0.985336 5.7675C0.643336 6.1095 0.643336 6.6645 0.985336 7.0045C1.15634 7.1765 1.37934 7.2615 1.60334 7.2615C1.82834 7.2615 2.05134 7.1765 2.22234 7.0055L3.99834 5.2295L5.77834 7.0085C5.94934 7.1795 6.17234 7.2645 6.39634 7.2645C6.62034 7.2645 6.84434 7.1785 7.01534 7.0085C7.35734 6.6665 7.35734 6.1125 7.01534 5.7705Z",
    fill: "gray"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseMark);
export default __webpack_public_path__ + "static/media/close-mark.e532bcb0978d031c2a4a71218e4bbeef.svg";
export { ForwardRef as ReactComponent };